// extracted by mini-css-extract-plugin
export default {"groupcard__pending-badge":"groups-nav_groupcard__pending-badge__R8ukk","mobile-plugs":"groups-nav_mobile-plugs__iDiul"};